<template>
  <div class="home-bg">
    <van-nav-bar class="title" :title="$route.meta.title" left-arrow fixed @click-left="onClickLeft" />
    <div class="content">
      <div class="top" align="center">
        <img v-if="listData[0].state === $t('viewBase.poor') || listData[0].state === $t('viewBase.overworked')" src="../../assets/images/history/history_detail_3.png">
        <img v-else-if="listData[0].state === $t('viewBase.yes') || listData[0].state === $t('viewBase.relaxed') || listData[0].state === $t('viewBase.attention')" src="../../assets/images/history/history_detail_12.png">
        <img v-else src="../../assets/images/history/history_detail_9.png">
      </div>
      <div class="heart">
        <span>{{ $t('viewBase.averageheartrate') }}</span>
        <div class="bpm">
          <div class="num">{{ Bpm }}</div>
          <div class="char">bpm</div>
        </div>
      </div>
      <!--条形图-->
      <div>
        <div v-for="(item, index) in listData" :key="index" class="item">
          <div class="item-one">
            <img :src="item.icon">
            <span v-if="item.state" class="name">{{ item.name }}：{{ item.state }}</span>
          </div>
          <div v-if="item.state" class="pic">
            <img v-if="item.state === $t('viewBase.poor') || item.state === $t('viewBase.overworked')" src="../../assets/images/history/history_icon_right.png">
            <img v-else-if="item.state === $t('viewBase.yes') || item.state === $t('viewBase.relaxed') || item.state === $t('viewBase.attention')" src="../../assets/images/history/history_icon_center.png">
            <img v-else src="../../assets/images/history/history_icon_left.png">
          </div>
          <div class="state">
            <span>{{ $t('viewBase.goodtwo') }}</span>
            <span class="bad">{{ $t('viewBase.poor') }}</span>
          </div>
        </div>
      </div>
      <!--按钮-->
      <div class="btn" align="center">
        <div class="common left-btn" align="center" @click="goPicPage('/heart/pic')">{{ $t('viewBase.viewECG') }}</div>
        <div class="common right-btn" align="center" @click="goResultPage('/analysis/result')">{{ $t('viewBase.next') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  data() {
    return {
      listData: [{
        icon: require('@/assets/images/history/history_detail_icon_heart.png'),
        name: this.$t('viewBase.heartratehealthy'),
        state: ''
      }, {
        icon: require('@/assets/images/history/history_detail_icon_pressure.png'),
        name: this.$t('viewBase.pressureindex'),
        state: ''
      }, {
        icon: require('@/assets/images/history/history_detail_icon_tried.png'),
        name: this.$t('viewBase.fatigueindex'),
        state: ''
      }],
      Bpm: 0,
      Url: '',
      State: ''
    }
  },
  mounted() {
    this.initFun()
  },
  methods: {
    // state: 心率，疲劳指数，压力指数，健康指数
    initFun: function() {
      this.Bpm = this.$route.query.bpm
      this.Url = this.$route.query.url
      this.State = this.$route.query.state
      if (this.State) {
        var arr = this.State.split(',')
        if (arr.length === 4) {
          this.listData[0].state = arr[3]
          this.listData[1].state = arr[2]
          this.listData[2].state = arr[1]
        }
      }
    },
    goResultPage: function(url) {
      this.$router.push({
        path: url,
        query: {
          bpm: this.Bpm,
          state: this.State
        }
      })
    },
    goPicPage: function(url) {
      if (!this.Url) {
        Toast(this.$t('viewBase.ECGpicturenot'))
        return
      }
      this.$router.push({
        path: url,
        query: {
          url: this.Url
        }
      })
    },
    onClickLeft() {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/')
      //   Toast('返回')
    }
  }
}
</script>

<style scoped lang="scss">
  .title{
    box-shadow:0px 3px 4px 0px rgba(190,190,190,0.3);
  }
  .home-bg{
    min-height: calc(100vh - 1rem);
    background: white;
  }
  .content{
    padding: 0px 42px;
  }
  .top{
    padding-top: 7px;
    img{
      width: 217px;
    }
  }
  .heart{
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    margin-top: -20px;
    span{
      color:rgba(125,125,125,1);
      font-size:13px;
      margin-right: 13px;
    }
    .bpm{
      float: right;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 68px;
      height: 68px;
      background-image: url(../../assets/images/home/bpm.png);
      background: url(../../assets/images/home/bpm.png) 100% 100%;
      background-size: contain;
      .num{
        font-size:27px;
        font-family:PingFang SC;
        font-weight:600;
        color:rgba(0,0,0,1);
        line-height:21px;
      }
      .char{
        font-size:11px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(0,0,0,1);
      }
    }
  }
  .item{
    .item-one{
      display: flex;
      align-items: center;
      .name{
        font-size:16px;
        font-family:PingFang SC;
        font-weight:400;
        color:rgba(23,23,23,1);
        line-height:26px;
      }
      img{
        width: 25px;
        height: 25px;
      }
      span{
        margin-left: 10px;
        font-size:16px;
        font-family:PingFang SC;
        color:rgba(23,23,23,1);
        line-height:26px;
      }
    }
    .pic{
      img{
        width: 100%;
      }
    }
    .bad{
      float: right;
      margin-right: 5px;
    }
    .state{
      margin-top: -10px;
      margin-bottom: 6px;
      font-size:14px;
      font-family:PingFang SC;
      font-weight:400;
      color:rgba(125,125,125,1);
      line-height:26px;
    }
  }
  .btn{
    padding-top: 18px;
    display: flex;
    justify-content: center;
    .common{
      width:134px;
      height:44px;
      border-radius:22px;
      font-size:16px;
      font-family:PingFang SC;
      line-height:26px;
      float: left;
      align-items: center;
      display: flex;
      justify-content: center;
    }
    .left-btn{
      border:1px solid rgba(255,131,15,1);
      color:rgba(255,131,15,1);
    }
    .right-btn{
      background:rgba(255,131,15,1);
      color:rgba(255,255,255,1);
      margin-left: 25px;
    }
  }
  /deep/.van-nav-bar .van-icon {
    color: #F18937;
    vertical-align: middle;
  }
</style>
